import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '../../route/auth/auth.service';
import { AppUrls } from '../../route/app-urls';
import { AppConfig } from '../../appconfig';
import { TranslatePipe } from '@ngx-translate/core';
import { SettingsService } from '../../shared/settings/settings.service';

import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatCard, MatCardHeader, MatCardContent } from '@angular/material/card';

@Component({
  selector: 'lfw-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  imports: [MatButton, MatTooltip, MatIcon, MatCard, MatCardHeader, MatCardContent, TranslatePipe]
})
export class LoginComponent implements OnInit {
  private authService = inject(AuthService);
  private config = inject(AppConfig);
  private settingsService = inject(SettingsService);

  public longVersion = '';
  public errorText = '';
  ngOnInit(): void {
    this.longVersion = 'Version ' + this.config.version();
  }

  login(e: any) {
    this.authService.login(AppUrls.baseUrlAngular);
  }

  showToolTip(): boolean {
    return this.settingsService.settings.viewMode.showTooltips;
  }

  showImprint(): boolean {
    return this.config.hasImprintLink();
  }

  showPrivacy(): boolean {
    return this.config.hasPrivacyLink();
  }

  showServerInfo(): boolean {
    return this.config.hasServerInfo();
  }

  urlImprint(): string {
    return this.config.urlImprint();
  }

  textImprint(): string {
    return this.config.textImprint();
  }

  urlPrivacy(): string {
    return this.config.urlPrivacy();
  }

  textPrivacy(): string {
    return this.config.textPrivacy();
  }

  serverInfo(): string {
    return this.config.serverInfo();
  }

  loginAllowed(): boolean {
    return !this.config.isLocked();
  }

  hasMessage(): boolean {
    return this.config.messageHeader().length > 0;
  }

  messageHeader(): string {
    return this.config.messageHeader();
  }

  messageText(): string {
    return this.config.messageText();
  }
}
